import { MouseEvent } from "react";
import TablePagination from "@mui/material/TablePagination";
import { PAGE_SIZE, displayedRowsLabel } from "./inactiveStores";

/** The page size is fixed; with a single option MUI leaves the rows-per-page picker out. */
const ROWS_PER_PAGE_OPTIONS = [PAGE_SIZE];

interface StorePaginationProps {
  count: number;
  /** 0-based. */
  page: number;
  onPageChange: (page: number) => void;
}

export default function StorePagination({
  count,
  page,
  onPageChange,
}: Readonly<StorePaginationProps>) {
  const handlePageChange = (_event: MouseEvent<HTMLButtonElement> | null, nextPage: number) =>
    onPageChange(nextPage);

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={handlePageChange}
      rowsPerPage={PAGE_SIZE}
      rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
      labelDisplayedRows={displayedRowsLabel}
    />
  );
}
